/**
 * Devices wrapper — 페어링 코드 + API 키/디바이스 관리.
 *
 * 둘 다 "PC ↔ 워크스페이스 연결" 의 lifecycle:
 *   - 페어링 = 처음 본체 앱 깔 때 워크스페이스에 연결
 *   - API 키 / 디바이스 = 일상 운영 / 사고 시 lock·wipe
 */

import { PairingPage } from './Pairing';
import { DevicesPage } from './Devices';

export type DeviceGroupSub = 'pairing' | 'apikeys';

export function DeviceGroupPage({ sub }: { sub: DeviceGroupSub }) {
  if (sub === 'pairing') return <PairingPage />;
  return <DevicesPage />;
}
